<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="border-0 mx-auto container-xl">
      <div class="title-area">
        <h1 class="page-title h2 mb-2">Consultant materials</h1>
      </div>
      <b-form-input v-model="search" type="search" placeholder="Search" class="mb-3"
        @keyup="consultantmaterials_get" />
      <b-table id="materials" ref="materials" hover class="actions-table" :items="materials" :fields="fields"
        :busy="loading" :sort-by="orderby" :sort-desc="orderdesc" :no-local-sorting="true"
        @sort-changed="materials_sort" @row-clicked="showmaterial">
        <template v-slot:cell(material_heading)="data">
          <fa-icon v-if="data.item.material_extension=='doc'||data.item.material_extension=='docx'" name="file-word" />
          <fa-icon v-if="data.item.material_extension=='xls'||data.item.material_extension=='xlsx'" name="file-excel" />
          <fa-icon v-if="data.item.material_extension=='ppt'||data.item.material_extension=='pptx'"
            name="file-powerpoint" />
          <fa-icon v-if="data.item.material_extension=='pdf'" name="file-pdf" />
          {{ data.item.material_heading }}
        </template>
        <template v-slot:cell(actions)="data">
          <div class="d-flex justify-content-end">
            <b-dropdown right class="ml-2">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <b-dropdown-item @click.prevent="showmaterial(data.item);">
                Download
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import { config } from '../../config'
import Breadcrumb from './Breadcrumb.vue'
const fields = [
  { key: 'material_heading', label: 'Heading', sortable: true },
  { key: 'material_date', label: 'Latest update', sortable: true, tdClass: 'text-left', thClass: 'text-left' },
  { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
]

export default {
  name: 'ConsultantMaterials',
  components: {
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      fields: fields,
      materials: [],
      usergroup_id: 1,
      loading: false,
      currentPage: 1,
      perPage: 999999,
      orderby: 'material_heading',
      order: 'ASC',
      orderdesc: false,
      search: ''
    }
  },
  created () {
    this.consultantmaterials_get()
  },
  methods: {
    showmaterial (item) {
      var reporturl = config.report_url + '/gdq_materials.php?r=' + item.id
      var downloadURL = new URL(reporturl)
      var downloadLink = document.createElement('a')
      downloadLink.href = downloadURL
      downloadLink.setAttribute('download', 'GDQ_Material_' + item.id + '.' + item.material_extension)
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    materials_sort () {
    },
    consultantmaterials_get () {
      this.loading = true
      var filter = ''
      if (this.search != '') {
        filter = {
          material_heading: {
            operator: 'LIKE',
            value: '%' + this.search + '%'
          }
        }
      } else {
        filter = {
          id: {
            operator: ' > ',
            value: 0
          }
        }
      }
      if (this.usergroup_id != 0) {
        filter.material_usergroup_id = {
          operator: ' = ',
          value: this.usergroup_id
        }
      }
      this.$store.dispatch('materials_fetch', {
        start: this.currentPage - 1,
        limit: this.perPage,
        orderby: this.orderby,
        order: (this.orderdesc == false) ? 'ASC' : 'DESC',
        filter: filter,
        usergroup_id: this.filterusergroup
      })
        .then((resp) => {
          this.materials = []
          var item
          var icon
          var ext
          for (var i = 0; i < resp.data.result.length; i++) {
            item = resp.data.result[i]
            ext = item.material_extension.toLowerCase()
            var result = {
              id: item.id,
              material_type: '<span class="' + icon + '"></span>',
              material_heading: item.material_heading,
              material_date: this.format_date(item.material_date),
              material_extension: ext
            }
            this.materials.push(result)
          }
          this.rows = resp.data.total
          this.loading = false
        })
    },
    //= ================
    // HELPER FUNCTIONS
    //= ================
    format_date (date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()
      if (isNaN(year)) { return '' }
      if (Number.isNaN(month)) { return '' }
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    format_time (date) {
      if (date.length == 5) {
        return date
      }
      var d = new Date(date)
      var h = d.getHours()
      var m = d.getMinutes()
      var hour = (h > 9 ? '' : '0') + h
      var minute = (m > 9 ? '' : '0') + m
      var thistime = hour + ':' + minute
      return thistime
    }
  }
}
</script>
<style></style>
